'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function stubFalse() {
    return false;
}

exports.stubFalse = stubFalse;
